import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import Cookies from 'js-cookie'
import store from '../vuex/store';
import router from '../router'
import { getLang } from '@/base/cookie'

/*
let baseURL = '';
if (process.env.NODE_ENV === 'development') {
  baseURL = '/index_xys.php'
  baseURL = process.env.BASE_API
} else {
  baseURL = process.env.BASE_API
}
*/

const service = axios.create({
  baseURL:process.env.BASE_API,
  timeout: 3600 * 1000 // request timeout
})


service.interceptors.request.use(config => {
  if (Cookies.get('admin_token_wm') && Cookies.get('admin_token_wm') !== undefined) {
    config.headers['admin-token'] = Cookies.get('admin_token_wm')
  }

  if (Cookies.get('admin_theme_id_wm') && Cookies.get('admin_theme_id_wm') !== undefined) {
    const theme_id = Cookies.get('admin_theme_id_wm');
    config.headers['theme-id'] = theme_id;
    //store.commit('app/set_theme_id',theme_id);
  }
  config.headers['accept-language']= getLang()
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  // response => response.data,
  response => {
    if (response.data && response.data.code === 200) {
      return response.data
    } else {
      if (response.data.code === 400 && response.data.message) {
        return response.data
      }
      if (response.data.code === 101 || response.data.code === 401) {
        router.push('/login')
        store.commit('app/set_login_dialog_isShow',true)
        return response.data
      }
      console.log(response.data)
      return response.data
    }

  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      showClose: true,
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/base/request.js